import { useState } from 'react';
import TickerSearchModal from './TickerSearchModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders, faMagnifyingGlass, faListCheck, faChartSimple, faPeopleRoof, faTableCells } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation, useNavigate } from '@remix-run/react';


interface MobileFooterStickyProps {
  isAuthenticated: boolean;
}

const MobileFooterSticky = ({ isAuthenticated = false }: MobileFooterStickyProps) => {
  const navigate = useNavigate();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [tickerSearchModalMode, setTickerSearchModalMode] = useState<"financials" | "insider-activity" | null>(null);
  const location = useLocation();

  return (
    <div id="mobile-footer-nav-bar" className="lg:hidden bg-background-dark fixed bottom-0 w-full z-4 border">
      <div className="flex justify-between items-center text-gray-500 [&_svg]:!w-6 [&_svg]:!h-6">
        <div className={`w-1/5 p-1 py-3 border-t-[3px] ${(location.pathname === '/screener' || location.pathname === '/') ? 'border-black text-black' : 'border-transparent'}`}>
          <Link
            to="/screener"
            className="text-2xl flex flex-col items-center leading-6"
          >
            <FontAwesomeIcon icon={faSliders} />
          </Link>
        </div>
        <div className="w-1/5 p-1 py-3 border-t-[3px] border-transparent">
          <div
            role="button"
            tabIndex={0}
            onClick={() => {
              if (isAuthenticated) {
                setTickerSearchModalMode("financials");
                setShowSearchModal(true);
              } else {
                // redirect /sign-in
                navigate('/sign-in');
              }
            }}
            className="text-2xl flex flex-col items-center leading-6"
          >
            <FontAwesomeIcon icon={faChartSimple} />
          </div>
        </div>
        <div className={`w-1/5 p-1 py-3 border-t-[3px] focus:outline-none ${location.pathname.includes('/ticker') ? 'border-black text-black' : 'border-transparent'}`}>
          <div
            role="button"
            tabIndex={0}
            onClick={() => {
              setTickerSearchModalMode(null);
              setShowSearchModal(true);
            }}
            className="text-2xl flex flex-col items-center leading-6"
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </div>
        </div>
        <div className="w-1/5 p-1 py-3 border-t-[3px] border-transparent">
          <div
            role="button"
            tabIndex={0}
            onClick={() => {
              if (isAuthenticated) {
                setTickerSearchModalMode("insider-activity");
                setShowSearchModal(true);
              } else {
                navigate('/sign-in');
              }
            }}
            className="text-2xl flex flex-col items-center leading-6"
          >
            <FontAwesomeIcon icon={faPeopleRoof} />
          </div>
        </div>
        {/* <div className="w-1/5 p-1 py-3 border-t-[3px] border-transparent">
          <Link
            to="/stocks-grid"
            className="text-2xl flex flex-col items-center leading-6"
          >
            <FontAwesomeIcon icon={faTableCells} />
          </Link>
        </div> */}
        <div className={`w-1/5 p-1 py-3 border-t-[3px] ${location.pathname === '/evaluation-checklist' ? 'border-black text-black' : 'border-transparent'}`}>
          <Link
            to="/evaluation-checklist"
            className="text-2xl flex flex-col items-center leading-6"
          >
            <FontAwesomeIcon icon={faListCheck} />
          </Link>
        </div>
      </div>
      {
        showSearchModal && (
          <TickerSearchModal showSearchModal={showSearchModal} setShowSearchModal={setShowSearchModal} mode={tickerSearchModalMode} />
        )
      }
    </div>
  );
};

export default MobileFooterSticky;